import { Flex } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { Grid, Paper } from '@material-ui/core';
import { differenceInCalendarMonths } from 'date-fns';

import { Cross } from 'assets/assetsV1/iconComponents';

import { isMobileView } from 'constants/isMobileView';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { MARKERS } from './DateRangePicker';
import DefinedRanges from './DefinedRanges';
import { Footer } from './Footer';
import Month from './Month';

const isEmptyDateRange = (dateRange) => {
  if (dateRange?.startDate && dateRange?.endDate) return false;
  return true;
};

const Menu = (props) => {
  const {
    ranges,
    dateRange,
    minDate,
    maxDate,
    firstMonth,
    setFirstMonth,
    secondMonth,
    setSecondMonth,
    setDateRange,
    helpers,
    handlers,
    placeholderText,
    onClose,
    onClear,
    onSelect,
    showPredefinedRanges,
    enableEmptyDateRangeToBeSelected,
    displayTwoMonthsLayout = true,
    displayCancelButton = true,
    displayClearButton = true,
  } = props;

  const isDateRangeSelected = !isEmptyDateRange(dateRange);

  // const { startDate, endDate } = dateRange;
  const canNavigateCloser = differenceInCalendarMonths(secondMonth, firstMonth) >= 2;
  const singleMonthViewNavState = [true, true];
  if (maxDate) {
    singleMonthViewNavState[1] = differenceInCalendarMonths(maxDate, firstMonth) >= 1;
  }
  if (minDate) {
    singleMonthViewNavState[0] = differenceInCalendarMonths(firstMonth, minDate) >= 1;
  }

  const commonProps = {
    dateRange,
    minDate,
    maxDate,
    helpers,
    handlers,
  };
  return (
    <Container displayTwoMonthsLayout={displayTwoMonthsLayout}>
      <Flex p="12px" mb="12px" alignItems="center">
        <TextBodyMedium bold>{placeholderText}</TextBodyMedium>
        <Cross ml="auto" onClick={onClose} cursor="pointer" />
      </Flex>
      {showPredefinedRanges && <DefinedRanges selectedRange={dateRange} ranges={ranges} setRange={setDateRange} />}
      <Grid container direction="row" wrap="nowrap">
        <Grid>
          <Grid
            container
            direction={isMobileView() ? 'column' : 'row'}
            style={{ marginBottom: 0 }}
            justifyContent="center"
            wrap="nowrap"
          >
            <Month
              {...commonProps}
              value={firstMonth}
              setValue={setFirstMonth}
              navState={displayTwoMonthsLayout ? [true, canNavigateCloser] : singleMonthViewNavState}
              marker={MARKERS.FIRST_MONTH}
              mr="4px"
            />
            {displayTwoMonthsLayout && (
              <Month
                {...commonProps}
                value={secondMonth}
                setValue={setSecondMonth}
                navState={[canNavigateCloser, true]}
                marker={MARKERS.SECOND_MONTH}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid>
        <Footer
          onClose={onClose}
          onClear={onClear}
          onSelect={onSelect}
          selectDisabled={!isDateRangeSelected}
          enableEmptyDateRangeToBeSelected={enableEmptyDateRangeToBeSelected}
          displayCancelButton={displayCancelButton}
          displayClearButton={displayClearButton}
        />
      </Grid>
    </Container>
  );
};

const Container = styled(Paper)`
  box-shadow:
    2px 0px 4px 3px rgba(0, 0, 0, 0.12),
    0px 4px 4px 3px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  overflow: visible;
  width: ${({ displayTwoMonthsLayout }) => {
    if (isMobileView()) return '100%';
    return displayTwoMonthsLayout ? '652px' : '334px';
  }};
  height: auto;
  padding: 12px;
`;

export default Menu;
